/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 20/10/2023
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const issueService = createApi({
    reducerPath: 'issueService',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://issueproxy.server.fouroots.com/' }),
    endpoints: (builder) => ({
        createMessage: builder.mutation({
            query: (data) => ({
                url: '/n_ach/issue_api/v1/issues',
                method: 'POST',
                body: data
            }),
        }),
    }),
})

export const { useCreateMessageMutation } = issueService